__turbopack_context__.v({
  "advert": "SelectionItem-module-sass-module__A8JALa__advert",
  "afisha-selected": "SelectionItem-module-sass-module__A8JALa__afisha-selected",
  "cover": "SelectionItem-module-sass-module__A8JALa__cover",
  "cover-additional": "SelectionItem-module-sass-module__A8JALa__cover-additional",
  "cover-main": "SelectionItem-module-sass-module__A8JALa__cover-main",
  "date": "SelectionItem-module-sass-module__A8JALa__date",
  "description": "SelectionItem-module-sass-module__A8JALa__description",
  "favorite": "SelectionItem-module-sass-module__A8JALa__favorite",
  "header-selection": "SelectionItem-module-sass-module__A8JALa__header-selection",
  "main": "SelectionItem-module-sass-module__A8JALa__main",
  "pagination": "SelectionItem-module-sass-module__A8JALa__pagination",
  "promo": "SelectionItem-module-sass-module__A8JALa__promo",
  "recommended": "SelectionItem-module-sass-module__A8JALa__recommended",
  "restaurants-item": "SelectionItem-module-sass-module__A8JALa__restaurants-item",
  "restaurants-list": "SelectionItem-module-sass-module__A8JALa__restaurants-list",
  "title": "SelectionItem-module-sass-module__A8JALa__title",
});
